// extracted by mini-css-extract-plugin
export default {"logo":"Contacts_logo__ccG+H"};